namespace RioERP.Invoices {
    export interface InvoicePaymentForm {
        InvoiceId: Serenity.LookupEditor;
        EPaymentMode: Serenity.EnumEditor;
        Amount: Serenity.DecimalEditor;
        EStatus: Serenity.EnumEditor;
        Note: Serenity.StringEditor;
        ChequeNumber: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        TransactionId: Serenity.StringEditor;
        PaymentDate: Serenity.DateEditor;
    }

    export class InvoicePaymentForm extends Serenity.PrefixedContext {
        static formKey = 'Invoices.InvoicePayment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoicePaymentForm.init)  {
                InvoicePaymentForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.EnumEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;
                var w4 = s.DateEditor;

                Q.initFormType(InvoicePaymentForm, [
                    'InvoiceId', w0,
                    'EPaymentMode', w1,
                    'Amount', w2,
                    'EStatus', w1,
                    'Note', w3,
                    'ChequeNumber', w3,
                    'BankName', w3,
                    'TransactionId', w3,
                    'PaymentDate', w4
                ]);
            }
        }
    }
}
